// AgentCommissionMasterEditModal.jsx

import React, { useEffect, useState } from "react";
import axios from "axios";

const API = "https://payyug.in/api";

const fields = [
  { label: "Loan Applied",    valueKey: "loanAppliedValue",    typeKey: "loanAppliedType" },
  { label: "Loan Disbursed",  valueKey: "loanDisbursedValue",  typeKey: "loanDisbursedType" },
  { label: "EMI Collection",  valueKey: "emiCollectionValue",  typeKey: "emiCollectionType" },
  { label: "Saving",          valueKey: "savingValue",         typeKey: "savingType" },
  { label: "RD",              valueKey: "rdValue",             typeKey: "rdType" },
  { label: "DD",              valueKey: "ddValue",             typeKey: "ddType" },
  { label: "FD",              valueKey: "fdValue",             typeKey: "fdType" },
  { label: "MIS",             valueKey: "misValue",            typeKey: "misType" },
];

const AgentCommissionMasterEditModal = ({ isOpen, onClose, item, onUpdated }) => {
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (item) setFormData({ ...item });
  }, [item]);

  if (!isOpen || !formData) return null;

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpdate = async () => {
    try {
      await axios.put(
        `${API}/update-agent-commison-master/${formData.id}`,
        formData
      );
      alert("Updated Successfully");
      onUpdated();
      onClose();
    } catch (err) {
      console.error(err);
      alert("Update Failed");
    }
  };

  return (
    // ── Same overlay pattern as EmployeeReport ────────────────────────────────
    <div
      className="loan-pre-closer-modal-overlay"
      onClick={onClose}
    >
      <div
        className="acm-edit-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="acm-edit-dialog__header">
          <h2 className="acm-edit-dialog__title">Edit Commission</h2>
          <button className="acm-edit-dialog__close" onClick={onClose}>×</button>
        </div>

        {/* Body */}
        <div className="acm-edit-dialog__body">

          {/* Column headers */}
          <div className="acm-edit-dialog__row acm-edit-dialog__row--head">
            <span>Type</span>
            <span>Commission Type</span>
            <span>Value</span>
          </div>

          {fields.map((f) => (
            <div key={f.valueKey} className="acm-edit-dialog__row">
              <span className="acm-edit-dialog__row-label">{f.label}</span>

              <select
                className="acm-edit-dialog__select"
                value={formData[f.typeKey] || "fixed"}
                onChange={(e) => handleChange(f.typeKey, e.target.value)}
              >
                <option value="percentage">Percentage</option>
                <option value="fixed">Fixed</option>
              </select>

              <input
                className="acm-edit-dialog__input"
                type="number"
                min="0"
                value={formData[f.valueKey] || ""}
                onChange={(e) => handleChange(f.valueKey, e.target.value)}
                placeholder="0"
              />
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="acm-edit-dialog__footer">
          <button className="loan-pre-closer-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="loan-pre-closer-btn-confirm" onClick={handleUpdate}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentCommissionMasterEditModal;